module.exports = __webpack_public_path__ + "static/media/expand-icon.b15d49f9.svg";